var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"app-notifications"}},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.$t("notifications.title")))]),_c('NotificationsList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }